import { useState } from "react";
import { errorMessage } from "../api";
import { browserTimeZone } from "../lib/tz";
import { currentMembership, toast, updateProfile } from "../store/app";
import { useApp } from "../store/hooks";
import { Modal } from "./bits";
import { isKnownTimeZone, TimeZoneSelect } from "./TimeZoneSelect";

export function ProfileDialog({ onClose }: { onClose: () => void }) {
  const me = useApp((s) => s.me);
  const browserZone = browserTimeZone();
  const [name, setName] = useState(
    me?.account.display_name ?? currentMembership()?.actor.display_name ?? "",
  );
  const [tz, setTz] = useState(me?.account.timezone ?? browserZone);
  const [useOrgDefault, setUseOrgDefault] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <Modal title="Profile" onClose={onClose}>
      <form
        className="form"
        onSubmit={async (e) => {
          e.preventDefault();
          if (!useOrgDefault && !isKnownTimeZone(tz)) {
            setError("Please choose a time zone from the list.");
            return;
          }
          setBusy(true);
          setError(null);
          try {
            await updateProfile({ display_name: name.trim() || undefined, timezone: useOrgDefault ? null : tz });
            toast("Profile saved", "success");
            onClose();
          } catch (err) {
            setError(errorMessage(err));
          } finally {
            setBusy(false);
          }
        }}
      >
        <p className="muted small">Signed in as {me?.account.email}</p>
        <label className="field">
          <span>Display name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} required autoComplete="name" />
        </label>
        <label className="check-row small">
          <input type="checkbox" checked={useOrgDefault} onChange={(e) => setUseOrgDefault(e.target.checked)} />
          Use the organization's default time zone
        </label>
        {!useOrgDefault && <TimeZoneSelect value={tz} onChange={setTz} suggestion={browserZone} />}
        <p className="muted small">
          Times are shown in this zone. Task-line times you type (<code>due:2026-10-31T14:00</code>) are read in it too.
        </p>
        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}
        <div className="form-actions">
          <button type="button" className="btn" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn primary" disabled={busy}>
            {busy ? "Saving…" : "Save"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
